<template>
  <div id="companyIndustry">
    <Header></Header>
    <div style="width: 1920px;height: 500px;border: 1px solid darkblue">
      444
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
export default {
  name: "index",
  components:{
    Footer,
    Header
  }

}
</script>

<style scoped>

</style>